import { useState } from 'react';
import { Row, Col, Form, Container } from 'react-bootstrap';
import { ControlButtons } from '../ControlButtons';
import { aboveGroundTankDetails } from '../../schemas/aboveGroundTankDetails';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

export const AboveGroundTankDetails = ({
	currAboveGroundInstallationDetails = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const [timePeriod, setTimePeriod] = useState(
		currAboveGroundInstallationDetails.timePeriod
	);
	const [aboveGroundInstallationDetails, setAboveGroundInstallationDetails] =
		useState(currAboveGroundInstallationDetails);
	const { register, handleSubmit, formState } = useForm({
		resolver: yupResolver(aboveGroundTankDetails),
		defaultValues: {
			numberOfTanks: currAboveGroundInstallationDetails.numberOfTanks || 0,
			tankSize: currAboveGroundInstallationDetails.tankSize || 0,
			contents: currAboveGroundInstallationDetails.contents ?? '',
			tankType: currAboveGroundInstallationDetails.tankType ?? '',
			installer: currAboveGroundInstallationDetails.installer ?? '',
			timePeriod: currAboveGroundInstallationDetails.timePeriod ?? '',
			removalDate: currAboveGroundInstallationDetails.removalDate ?? '',
		},
	});
	return (
		<>
			<Container className="mt-5 component">
				<h2 className="mb-4">Please provide the following details</h2>

				<div className="mb-4">
					<p className="mb-0">
						All tanks must comply with regulations set forth in IFC chapter 57
						and NFPA 30.
					</p>
					<p>
						All plans must be submitted and approved by the Utah County Fire
						Marshal prior to installation. A 48-hour installation notice is
						required.
					</p>
				</div>

				<Row>
					<Col xs="12" md="2">
						<Form.Group>
							<Form.Label>Tank Type:</Form.Label>
							<Form.Check
								required
								className="inline-radio"
								type="radio"
								name="tankType"
								label="Gravity"
								value="gravity"
								{...register('tankType')}
							/>
							<Form.Check
								required
								className="inline-radio"
								type="radio"
								name="tankType"
								label="Pump"
								value="pump"
								{...register('tankType')}
							/>
							<Form.Text className="text-danger">
								{formState.errors.tankType?.message}
							</Form.Text>
						</Form.Group>
					</Col>
					<Col xs="12" md="10">
						<Form.Group className="mb-3">
							<Form.Label>Installer:</Form.Label>
							<Form.Control type="text" {...register('installer')} />
							<Form.Text className="text-danger">
								{formState.errors.installer?.message}
							</Form.Text>
						</Form.Group>
					</Col>
				</Row>

				<Row className="">
					<Col xs="12" md="2">
						<Form.Group>
							<Form.Label>Time Period:</Form.Label>
							<br id="timePeriodBreak" />
							<Form.Check
								className="inline-radio"
								required
								type="radio"
								name="timePeriod"
								label="Permanent"
								value="perm"
								onClick={() => {
									setTimePeriod('perm');
								}}
								onChange={() => {
									setTimePeriod('perm');
								}}
								{...register('timePeriod')}
							/>
							<Form.Check
								className="inline-radio"
								required
								type="radio"
								name="timePeriod"
								label="Temporary"
								value="temp"
								onClick={() => {
									setTimePeriod('temp');
								}}
								onChange={() => {
									setTimePeriod('temp');
								}}
								{...register('timePeriod')}
							/>
							<Form.Text className="text-danger">
								{formState.errors.timePeriod?.message}
							</Form.Text>
						</Form.Group>
					</Col>
					<Col xs="12" md="10">
						<Form.Group className="mb-3">
							<Form.Label>Removal Date:</Form.Label>
							<Form.Control
								type="date"
								disabled={timePeriod === 'perm'}
								{...register('removalDate')}
							/>
							<Form.Text className="text-danger">
								{timePeriod === 'temp'
									? formState.errors.removalDate?.message
									: null}
							</Form.Text>
						</Form.Group>
					</Col>
				</Row>

				<Row>
					<Col xs="12" md="6">
						<Form.Group className="mb-3">
							<Form.Label>Number of Tanks:</Form.Label>
							<Form.Control type="number" {...register('numberOfTanks')} />
							<Form.Text className="text-danger">
								{formState.errors.numberOfTanks?.message}
							</Form.Text>
						</Form.Group>
					</Col>
					<Col xs="12" md="6">
						<Form.Group className="mb-3">
							<Form.Label>Tank Size:</Form.Label>
							<Form.Control type="number" {...register('tankSize')} />
							<Form.Text className="text-danger">
								{formState.errors.tankSize?.message}
							</Form.Text>
						</Form.Group>
					</Col>
				</Row>

				<Row>
					<Form.Group as={Col} xs={12} md={6}>
						<Form.Label className="pr-3">Contents</Form.Label>
						<Form.Control
							as="select"
							value={aboveGroundInstallationDetails.contents}
							{...register('contents')}
							onChange={e => {
								const { value } = e.target;
								setAboveGroundInstallationDetails({
									...aboveGroundInstallationDetails,
									contents: value,
								});
							}}>
							<option value="gas">Gasoline</option>
							<option value="diesel">Diesel</option>
							<option value="other">Other</option>
						</Form.Control>
						<Form.Text className="text-danger">
							{formState.errors.contents?.message}
						</Form.Text>
					</Form.Group>
				</Row>

				<Row>
					{aboveGroundInstallationDetails.contents === 'other' && (
						<Form.Group as={Col} xs={12} md={6}>
							<Form.Control
								className="p-2"
								as="textarea"
								placeholder="Please describe content..."
								{...register('contentDescription')}></Form.Control>
							<Form.Text className="text-danger">
								{formState.errors.contentDescription?.message}
							</Form.Text>
						</Form.Group>
					)}
				</Row>
			</Container>
			<Container>
				<ControlButtons
					onNext={handleSubmit(onNext)}
					onPrev={onPrevious}
					onSubmit={handleSubmit(onSubmit)}
					disablePrev={disablePrev}
					disableNext={disableNext}
					finalStep={finalStep}></ControlButtons>
			</Container>
		</>
	);
};
